<template>
  <div class="opc-cart__count">
    <span class="opc-cart__count__title">{{ planCountDesc }}</span>
    <share-link />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ShareLink from './share-link.vue';

export default {
  name: 'PlanCount',
  components: {
    ShareLink,
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'openInvoiceCartItemCount']),
    plansCount() {
      return this.getSelectedPlans.length + this.openInvoiceCartItemCount;
    },
    planCountDesc() {
      return `${this.plansCount} ${this.$t('billing.order_summary.item_ss')}`;
    },
  },
};
</script>

<style lang="scss">
.opc-cart {
  &__count {
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #515079;
    padding-bottom: 12px;
    border-bottom: 1px solid #dfdfe4;
    margin-bottom: 24px;

    &__title:has(~ .opc-cart__sharelink) {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
